import BaseForm from './base-form';

export default BaseForm;
